import { useWizard } from "storev2/wizardStore";

function getDefault() {
  const { updateWizard } = useWizard.getState();
  // const session = getStorage("ctxSession");
  // const shop = { id: session.shop_.id, name: session.shop_.name };
  // const user = { id: session.user, name: session.user_name };
  // // FIXME --------------------
  // const operation_center = { id: 1, name: "Default Operation Center" };
  // FIXME

  const toStore = {};
  updateWizard(toStore);
  return toStore;
}

function layout(props) {
  const session = getDefault();
  const ctxView = {
    model: "account_statement_co.cash_up.start",
    reportName: "account_statement_co.cash_up_report",
    fields: {
      operation_center: {
        type: "many2one",
        model: "company.operation_center",
        searchable: true,
        required: true,
        default: session.operation_center,
      },
      shop: {
        type: "many2one",
        model: "sale.shop",
        searchable: true,
        required: true,
        default: session.shop,
      },
      user: {
        type: "many2one",
        model: "res.user",
        searchable: true,
        required: true,
        default: session.user,
      },
      date: {
        type: "date",
        required: true,
      },
    },
    list: [],
    form: [{ name: "shop" }, { name: "date" }, { name: "user" }],
  };
  if (props?.operationCenter) {
    ctxView.form.unshift({
      name: "operation_center",
    });
  }

  return ctxView;
}

export { layout };
